import { ValidationError } from '@types';

export const getPartialSplitAmountErrors = (
  value: string,
  minAmount: number,
  pendingAmount: number
): ValidationError => {
  const n = Number(value);
  if (Number.isNaN(n)) return {};
  if (n < minAmount) {
    return {
      minAmount: `Amount should be minimum Rs ${minAmount} or more`
    };
  }
  if (n > pendingAmount) {
    return {
      maxAmount: `Amount should be less than Rs ${pendingAmount}`
    };
  }
  const remainingBalance = pendingAmount - n;
  if (remainingBalance > 0 && remainingBalance < minAmount) {
    return {
      minRemaining: `Remaining balance should be at least Rs ${minAmount}`
    };
  }
  return {};
};

export const getPartialSplitErrorMessage = (errors: ValidationError) =>
  errors.minAmount || errors.maxAmount || errors.minRemaining;

export const hasPartialSplitError = (errors: ValidationError) =>
  Boolean(getPartialSplitErrorMessage(errors));

export const clearPartialSplitErrors = (
  errors: ValidationError
): ValidationError => {
  const { minAmount, maxAmount, minRemaining, ...rest } = errors;
  return rest;
};
